var m={S:{min:0,max:375},M:{min:376,max:768},L:{min:769,max:1024},XL:{min:1025,max:1280}};export{m as default};
